var _path, _path2, _path3, _path4, _path5, _path6;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLuckyChoiceBackground2(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 209,
    height: 206,
    viewBox: "0 0 209 206",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M205.681 0L202.399 11.5347L205.681 13.5812L208.876 6.69756L205.681 0Z",
    fill: "#FFDF86"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M82.9583 192.183L79.6764 203.717L82.9583 205.764L86.1537 198.88L82.9583 192.183Z",
    fill: "#EA5D63"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M162.698 113.539L168.879 115.94L168.573 108.609L164.436 104.694L162.698 113.539Z",
    fill: "#C5D4FA"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M0 25.2972L6.1806 27.6976L5.87453 20.3673L1.7371 16.4519L0 25.2972Z",
    fill: "#F59E1C"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M25.7855 100.592L22.5037 112.127L25.7855 114.173L28.981 107.29L25.7855 100.592Z",
    fill: "#FFC9C9"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M105.526 21.9484L111.706 24.3489L111.4 17.0186L107.263 13.1032L105.526 21.9484Z",
    fill: "#C5D4FA"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLuckyChoiceBackground2);
export default __webpack_public_path__ + "static/media/lucky-choice-background-2.fa968812bca557f20454c9924f200b26.svg";
export { ForwardRef as ReactComponent };